module.exports = __webpack_public_path__ + "static/banner-4a178710af16595ab28ab5bd6dd39d28.png";